import React from "react";
import { connect } from "react-redux";
import Truncate from "react-truncate";

import { goToMessage } from "state/teachers/actions";

import Card from "components/app/home/Card";
import BulletItem from "components/app/home/BulletItem";

class Message extends React.Component {
  
  goToMessage = () => {
    this.props.goToMessage(this.props.message.get("id"));
  }
  
  render() {
    const { message } = this.props;
    return (
      <div className="teachers-home-messages__link" onClick={this.goToMessage}>
        <Card className="teachers-home-messages__message">
          <BulletItem cssModifier="teachers">
            <div className="teachers-home-messages__message-body">
              <Truncate lines={3} trimWhitespace={true}>
                { message.get("body") }
              </Truncate>
            </div>
          </BulletItem>
        </Card>
      </div>
    );
  }
  
}

export default connect(
  undefined,
  { goToMessage }
)(Message);



// WEBPACK FOOTER //
// ./src/components/app/home/sections/teachers/Message.js